"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Validation {
    static validateAndGetEnvVar(variable) {
        const value = process.env[variable];
        if (!value) {
            const message = `Variable ${variable} is undefined or empty`;
            throw new Error(message);
        }
        return value;
    }
    static isEmptyOrWhiteSpace(value) {
        const regex = new RegExp(/^\s*$/);
        const isWhiteSpace = regex.test(value);
        const isEmpty = value === '';
        return isEmpty || isWhiteSpace;
    }
}
exports.Validation = Validation;
//# sourceMappingURL=validation.js.map